type Pending = {
  time: number;
  resolve: () => void;
  timeoutId: ReturnType<typeof setTimeout>;
};

let pending: Pending | null = null;

const ACK_TIMEOUT_MS = 10_000;

function settle(p: Pending): void {
  clearTimeout(p.timeoutId);
  p.resolve();
}

export function ackSimulationTime(time: number | string): void {
  if (!pending || pending.time !== time) return;
  const p = pending;
  pending = null;
  settle(p);
}

export function waitForSimulationTimeApplied(time: number): Promise<void> {
  if (pending) {
    const stale = pending;
    pending = null;
    settle(stale);
  }
  return new Promise((resolve) => {
    const timeoutId = setTimeout(() => {
      if (pending?.timeoutId === timeoutId) pending = null;
      resolve();
    }, ACK_TIMEOUT_MS);
    pending = { time, resolve, timeoutId };
  });
}

export function cancelPendingSimulationTimeAck(): void {
  if (pending) {
    const p = pending;
    pending = null;
    settle(p);
  }
}
